import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const StatsCard = ({ title, value, subtitle, IconComponent, iconColor }) => (
  <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
    <CardContent>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="subtitle1" fontWeight={'bold'} color="textSecondary">
            {title}
          </Typography>
          <Typography variant="h3" fontWeight={'bold'} sx={{ mt: 1 , color: iconColor || 'text.secondary'}}>
            {value}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {subtitle}
          </Typography>
        </Box>
        <IconComponent sx={{ fontSize: 32, color: iconColor }} />
      </Box>
    </CardContent>
  </Card>
);

export default StatsCard;
